import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

import { computed, StyleValue } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TopSlideDownModal',
  props: {
    height: { default: 170 },
    isOpen: { type: Boolean },
    style: { type: [Boolean, null, String, Object, Array], default: undefined },
    zIndex: { default: 999 }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "4ac0d2f6": (modalHeight.value),
  "6c3a9cf2": (_ctx.zIndex)
}))

const props = __props;
const modalHeight = computed(() => `${props.height}px`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal",
          style: _normalizeStyle(_ctx.style)
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 4))
      : _createCommentVNode("", true)
  ]))
}
}

})